<template>
  <div class="history">
    <component :is="componentName" v-if="privacyComponent"/>
    <Empty v-else-if="isLoaded" />
  </div>
</template>
<script>
import Empty from '@/components/Empty.vue'

export default {
  name: "History",
  components: { Empty },
  data () {
    return {
      privacyComponent: '',
      isLoaded: false
    }
  },
  computed: {
    componentName () {
      return this.privacyComponent || ''
    }
  },
  created () {
    this.loadPrivacy()
  },
  watch: {
    '$route' () {
      this.loadPrivacy()
    }
  },
  methods: {
    loadPrivacy () {
      const  { params: { version = '' }} = this.$route || {}
      const context = require.context('./components/', false,/\.vue$/)
      const isExist = Object.keys(context.keys()).length && (context.keys())?.includes(`./${version}.vue`)
      if (isExist) {
        const privacyComponent = (resolve) => require([`./components/${version}.vue`], resolve)
        this.privacyComponent = privacyComponent
      } else {
        this.privacyComponent = ''
      }
      this.isLoaded = true
    }
  }
}
</script>
